import { filtersHelper } from '@/utils';

export const documentModel = (data = {}) => ({
    uuid: data.uuid || '',
    name: data.name ||  '',
    description: data.description || '',
    fileName: data.file_name || data.name || '',
    fileUrl: data.file_path || data.file_url || '',
    link: data.link || data.external_url || data.file || data.file_path || data.file_url || '',
    documentCategoryUUID: data.document_category_uuid || data.document_category?.uuid || '',
    documentCategory: data.document_category || null,
    visibleToCompanyUUID: data.visible_to_company_uuid || data.visible_to_company?.uuid || '',
    visibleToCompany: data.visible_to_company || null,
    companyName: data.visible_to_company?.name || data.company_name || '',
    sequence: data.sequence == null ? null : Number(data.sequence),
    code: data.code || '',
    isInternal: Number(data.is_internal) === 1,
    isActive: data.is_active == null ? true : Number(data.is_active) === 1,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
});
